'use client';

import { QueryClientProvider } from '@ts-rest/react-query/tanstack';
import { ThemeProvider } from 'next-themes';
import type { PropsWithChildren } from 'react';

import { getQueryClient } from '@/libs/react-query/react-query';
import { tsr } from '@/libs/ts-rest/ts-rest';

import { Provider } from '@packages/web-design-systems';

import { candidateDesignSystem } from '../theme/theme';

const AppProviders = ({ children }: PropsWithChildren) => {
	const queryClient = getQueryClient();

	return (
		<QueryClientProvider client={queryClient}>
			<tsr.ReactQueryProvider>
				<Provider value={candidateDesignSystem}>
					<ThemeProvider attribute="class" disableTransitionOnChange forcedTheme="light">
						{children}
					</ThemeProvider>
				</Provider>
			</tsr.ReactQueryProvider>
		</QueryClientProvider>
	);
};

export default AppProviders;
